import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Table } from 'reactstrap';

export const Container = styled.div`
  padding: 0 20px 20px;
  height: calc(100vh - 136px);
  overflow-y: auto;
`;

export const Header = styled.div`
  margin: 0 0 20px 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
`;

export const Card = styled.div`
  width: 100%;
  min-width: 400px;
  background: ${(props) => props.theme.colors.white};
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.1));

  border-radius: 8px;
  padding: 20px;
`;

export const ColorSwatchColor = styled.div`
  background: ${({ primaryColor }) => primaryColor};
  width: 40px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
`;
